import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function K() {
    const { useLang, Link, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('camp');
    const [source, setSource] = useState('');
    const cards: any = [
        {
            img: '/responsive/picture/camp/11_1.jpg',
            text: t('secK_card1_text'),
            source: 'https://www.youtube.com/embed/S_B_N4W5UK4?si=rVY6nipZ8UK-RLlm',
        },
        {
            img: '/responsive/picture/camp/11_2.jpg',
            text: t('secK_card2_text'),
            source: 'https://www.youtube.com/embed/tTLG-NY5whM?si=h9FJ92dhtdS3g4si',
        },
        {
            img: '/responsive/picture/camp/11_3.jpg',
            text: t('secK_card3_text'),
            source: 'https://www.youtube.com/embed/YIxfSbQj3_w?si=Or7TVLaQ3mq1CCfg',
        },
    ];
    return (
        <div id="camp-K" className={`camp-K camp-box ${css['camp-K']}`}>
            <h2 className="title">{t('secK_title')}</h2>
            <Swiper
                className="cards"
                modules={[Scrollbar]}
                spaceBetween={20}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`card item-${k + 1}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                            <span className="play-icon" onClick={() => setSource(card?.source)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
                                    <path
                                        d="M45.4442 12.9435C45.2047 11.9867 44.7169 11.11 44.0302 10.402C43.3434 9.69397 42.482 9.17974 41.5329 8.91123C38.0652 8.06445 24.1942 8.06445 24.1942 8.06445C24.1942 8.06445 10.3232 8.06445 6.85549 8.99187C5.90639 9.26039 5.04496 9.77462 4.3582 10.4826C3.67145 11.1906 3.18369 12.0673 2.9442 13.0241C2.30955 16.5434 1.99911 20.1135 2.01678 23.6895C1.99416 27.2924 2.30462 30.8897 2.9442 34.4354C3.20823 35.3625 3.70691 36.2059 4.39207 36.884C5.07722 37.5621 5.92569 38.052 6.85549 38.3064C10.3232 39.2338 24.1942 39.2338 24.1942 39.2338C24.1942 39.2338 38.0652 39.2338 41.5329 38.3064C42.482 38.0379 43.3434 37.5236 44.0302 36.8156C44.7169 36.1077 45.2047 35.231 45.4442 34.2741C46.074 30.7814 46.3844 27.2385 46.3716 23.6895C46.3942 20.0865 46.0838 16.4892 45.4442 12.9435Z"
                                        fill="#FF0200"
                                    />
                                    <path d="M19.6582 30.2822L31.2509 23.6894L19.6582 17.0967V30.2822Z" fill="white" />
                                </svg>
                            </span>
                        </div>
                        <p className="card-text">{card.text}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
        </div>
    );
}
